// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1__Gi","cls2":"AutoCompleteResults-cls2_Lsr AutoCompleteResults-cls1__Gi"};